/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PrizePublic } from './PrizePublic';
import {
    PrizePublicFromJSON,
    PrizePublicFromJSONTyped,
    PrizePublicToJSON,
} from './PrizePublic';

/**
 * 
 * @export
 * @interface PrizesResponse
 */
export interface PrizesResponse {
    /**
     * List of active prizes available for claiming
     * @type {Array<PrizePublic>}
     * @memberof PrizesResponse
     */
    data: Array<PrizePublic>;
}

/**
 * Check if a given object implements the PrizesResponse interface.
 */
export function instanceOfPrizesResponse(value: object): value is PrizesResponse {
    let isInstance = true;
    isInstance = isInstance && "data" in value && value["data"] !== undefined;

    return isInstance;
}

export function PrizesResponseFromJSON(json: any): PrizesResponse {
    return PrizesResponseFromJSONTyped(json, false);
}

export function PrizesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PrizesResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(PrizePublicFromJSON)),
    };
}

export function PrizesResponseToJSON(value?: PrizesResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': ((value.data as Array<any>).map(PrizePublicToJSON)),
    };
}

